import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Monedas';

export interface MonedaEntity {
  iso: string;
  name: string;
  symbol: string;
}

export class MonedasAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarMonedas(): AxiosPromise<MonedaEntity[]> {
		return this.cliente.get(`/ListarMonedas`);
	}
}